import axios from "axios";
import { getDolphinAuthAPIKey, getDolphinAuthBaseURL } from "./BaseUrlUtils";

export function getDolphinAuthClient() {
  const dolphinAPIClient = axios.create({
    baseURL: getDolphinAuthBaseURL(),
    timeout: 5000,
    headers: { "X-API-Key": getDolphinAuthAPIKey() },
  });

  return dolphinAPIClient;
}

export async function axiosGETDolphinAuth(path, params) {
  try {
    const response = await getDolphinAuthClient().get(path, params);
    return response;
  } catch (error) {
    console.error("Error while connecting with DolphinAuthClient" + error);
    throw error;
  }
}

export const API_PATH = {
  GET_USERNAME_FOR_BARCODE: "getUsernameForBarcodeId",
};



// WEBPACK FOOTER //
// ./src/components/scanBarcode/network/NetworkUtils.js